import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from 'react-router-dom'
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MyTable from '../../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import XLSX from 'xlsx';
import { downloadBlob, s2ab } from "../../../../controllers/ExcelController";
import { applyMaskAmount, getMonthName } from "../../../utils/utils";

import _, { isEmpty } from 'lodash';

//Api
import { FundAPI } from '../../../../API/fund';
import { doGetAllLocalQuotasByFundId, computeQuotaRentsByMonthYear } from '../../../../controllers/FundLocalQuotasController';

//redux
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../../../../actions';

import { unoTheme, tabs, headerSearch } from '../../../../assets/styles/unoTheme';

const LightTooltip = withStyles((theme) => ({
    arrow: {
        "&:before": {
            border: "1px solid #000000"
        },
        color: theme.palette.common.white
    },
    tooltip: {
        backgroundColor: theme.palette.common.white,
        border: "1px solid #000000",
        color: "#000000"
    }
}))(Tooltip);

//Toggle de exibição da coluna "Início" (desde o início) na aba Outros fundos
const SHOW_RENT_INICIO = false;

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: unoTheme.greenMoney
    },
    red: {
        color: unoTheme.redMoney,
    },
    iconButton: {
        padding: '5px',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    tableTh: {
        background: unoTheme.mainColor,
        color: 'white',
    },
    selectableRow: {
        cursor: 'pointer',
        '& > *': {
            borderBottom: 'unset',
        },
        '&:nth-of-type(odd)': {
            backgroundColor: unoTheme.secondaryTuplaTable,
        },
        '&:hover': {
            background: unoTheme.hoverTable,
        }
    },
    table: {
        tableLayout: 'fixed',
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px 24px 16px 16px',
            },
        },
    },
    overflow: {
        overflowY: 'scroll',
    },
    tableSideGraph: {
        display: 'flex',
        flexDirection: 'row',
    },
    rightGraphs: {
        width: '30%',
    },
    clickAble: {
        cursor: 'pointer'
    },
    sectionTableCell: {
        display: 'table-cell',
        color: 'white',
        padding: '0px !important',
    },
    multipleHorizontalTableCell: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-around',
        '& > div': {
            flex: 1,
        }
    },
    infoIcon: {
        display: 'flex',
        fontSize: '18px',
        color: unoTheme.mainColor,
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto',
    },
    toogleButton: {
        maxHeight: '40px',
    },
    errorArticle: {
        color: unoTheme.errorColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .MuiSvgIcon-root': {
            fontSize: '20px',
            marginRight: '5px',
        }

    },
    iconExtraPolicys: {

        '& .MuiSvgIcon-root': {
            fontSize: '18px',
            verticalAlign: 'middle',
        }

    },
    tabs: tabs,

    sectionTableCellData: {
        display: 'table-cell',
        padding: '0px !important',
    },
    sortableSubHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        userSelect: 'none',
    },
});

const RENT_COLUMNS = ["rentMonth", "rentYear", "rent12m", "rent24m", "rentHistoric"];

export default function FundsAllScreen({ segmentId, search, flagDoExcelAllFunds, resetFlag }) {

    const classes = useStyles();
    const history = useHistory();

    const currentUser = useSelector(state => state.currentUser);
    const clientOn = useSelector(state => state.clientOn)

    const dispatch = useDispatch();

    const [funds, setFunds] = useState([]);
    const [itemsPage,] = useState(15);
    const [page, setPage] = useState(1);

    //Rentabilidades calculadas por fundId (lazy): undefined = não buscado, 'loading', ou objeto de rents
    const [rentsMap, setRentsMap] = useState({});
    //Geração do cache: incrementa quando o cache é invalidado (troca de mês/ano/segmento/cliente)
    const rentsGenRef = useRef(0);

    const month = clientOn?.client?.selectedPortfolioMonth;
    const year = clientOn?.client?.selectedPortfolioYear;

    //Ordenação: por padrão alfabética (asc) por nome do fundo
    const [orderBy, setOrderBy] = useState("fund_name");
    const [order, setOrder] = useState("asc");

    const SortIcon = ({ column }) => {
        const isActive = orderBy === column;
        if (!isActive) {
            return <ArrowDropDown style={{ color: "#ccc" }} />;
        }
        return order === "asc"
            ? <ArrowDropUp style={{ color: unoTheme.mainColor }} />
            : <ArrowDropDown style={{ color: unoTheme.mainColor }} />;
    };

    const handleSort = (column) => {
        if (orderBy === column) {
            setOrder(order === "asc" ? "desc" : "asc");
        } else {
            setOrderBy(column);
            setOrder(RENT_COLUMNS.includes(column) ? "desc" : "asc");
        }
        setPage(1);
    };

    async function loadInfos(segmentId) {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            emptyMessage: 'Carregando fundos...',
            cod: 'my_funds_screen'
        }));

        //Invalida cache de rentabilidades (mês/ano/segmento podem ter mudado) e volta à primeira página
        rentsGenRef.current += 1;
        setRentsMap({});
        setPage(1);

        console.log('ALL FUNDS segmentId: ', segmentId);

        let responseFunds = {};
        if (isEmpty(search)) {
            responseFunds = await FundAPI.getFundsBySegmentId(segmentId)
        } else {
            responseFunds = await FundAPI.getFundsBySearchAndSegmentId(search, segmentId);
        };
        if (responseFunds.success) {
            const responseFundsData = responseFunds.body.rows;
            console.log('responseFundsData: ', responseFundsData);
            if (isEmpty(responseFundsData)) {
                dispatch(allActions.innerLoadActions.setInnerLoad({
                    show: true,
                    emptyMessage: 'Não existem fundos',
                    cod: 'my_funds_screen'
                }));
            } else {
                dispatch(allActions.innerLoadActions.setInnerLoad({ show: false, cod: 'my_funds_screen' }));
            };

            setFunds(responseFundsData);
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: "Falha ao trazer fundos",
                type: 'error',
            }));
        }
    }

    function bladeFund(row) {
        history.push(
            {
                pathname: "/blade/all",
                state: { fund: row }
            }
        )
    }

    useEffect(() => {
        if (segmentId == null) return;
        loadInfos(segmentId);
    }, [clientOn,
        segmentId,
        search]);

    const selectable = useMemo(() => currentUser?.user?.isViewer ? undefined : "true", [currentUser]);

    //Lista completa ordenada. Por Fundo: alfabética (case-insensitive). Por rentabilidade:
    //usa os valores do rentsMap, com fundos sem valor (null/carregando) sempre no fim.
    const sortedFunds = useMemo(() => {
        if (!funds) return [];
        if (RENT_COLUMNS.includes(orderBy)) {
            const nullSentinel = order === "desc" ? -Infinity : Infinity;
            return _.orderBy(funds, [(f) => {
                const r = rentsMap[f.id];
                const v = (!r || r === 'loading') ? null : r[orderBy];
                return v == null ? nullSentinel : v;
            }], [order]);
        }
        return _.orderBy(funds, [(f) => (f.fund_name || '').toString().toLowerCase()], [order]);
    }, [funds, orderBy, order, rentsMap]);

    //Fundos exibidos na tela (paginados quando não há busca)
    const visibleFunds = useMemo(() => {
        if (!sortedFunds) return [];
        return isEmpty(search)
            ? sortedFunds.slice((page * itemsPage) - (itemsPage), itemsPage + (itemsPage * (page - 1)))
            : sortedFunds;
    }, [sortedFunds, page, itemsPage, search]);

    //Cálculo das rentabilidades com cache por fundId.
    //- Ordenando por Fundo: lazy, só os fundos visíveis.
    //- Ordenando por rentabilidade: calcula TODOS os fundos (com loading) para ordenar a lista completa.
    const sortingByRent = RENT_COLUMNS.includes(orderBy);
    useEffect(() => {
        if (!month || !year || !funds.length) return;

        const target = sortingByRent ? funds : visibleFunds;
        const toFetch = target.filter(f => rentsMap[f.id] === undefined);
        if (!toFetch.length) return;

        const gen = rentsGenRef.current;

        if (sortingByRent) {
            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: true,
                loadMessage: 'Calculando rentabilidades...',
                cod: 'my_funds_screen',
            }));
        }

        setRentsMap(prev => {
            const next = { ...prev };
            toFetch.forEach(f => { if (next[f.id] === undefined) next[f.id] = 'loading'; });
            return next;
        });

        (async () => {
            const results = await Promise.all(toFetch.map(async f => {
                const resp = await doGetAllLocalQuotasByFundId(f.id);
                const rents = (resp.success && Array.isArray(resp.body))
                    ? computeQuotaRentsByMonthYear(resp.body, month, year)
                    : {};
                return { id: f.id, rents };
            }));

            //Ignora resultados de uma geração antiga (cache foi invalidado por troca de mês/ano/segmento)
            if (rentsGenRef.current !== gen) return;
            setRentsMap(prev => {
                const next = { ...prev };
                results.forEach(r => { next[r.id] = r.rents; });
                return next;
            });

            if (sortingByRent) {
                dispatch(allActions.innerLoadActions.setInnerLoad({ show: false, cod: 'my_funds_screen' }));
            }
        })();
    }, [visibleFunds, funds, month, year, sortingByRent]);

    useEffect(() => {
        if (flagDoExcelAllFunds && funds && funds.length > 0) {
            doExcelAllFunds(
                "TODOS_FUNDOS_" + getMonthName(clientOn.client.selectedPortfolioMonth) + "_" + clientOn.client.selectedPortfolioYear,
                sortedFunds
            );
            resetFlag();
        }
    }, [flagDoExcelAllFunds, funds]);

    function s2ab(s) {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }

    function doExcelAllFunds(titleFile, funds) {
        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Gerando planilha...',
        }));

        const wb = XLSX.utils.book_new();
        wb.Props = {
            Title: "Todos os Fundos",
            Author: "UNO",
        }

        const sheetName = "Todos os Fundos";
        wb.SheetNames.push(sheetName);

        const ws_data = [];

        // Cabeçalhos
        const header = ['Fundo', 'CNPJ', 'Rentabilidade Mês (%)', 'Rentabilidade Ano (%)',
            'Rentabilidade 12m (%)', 'Rentabilidade 24m (%)'];
        if (SHOW_RENT_INICIO) header.push('Rentabilidade Início (%)');
        ws_data.push(header);

        // Dados (rentabilidades são calculadas de forma lazy; usa o que já foi computado)
        funds.forEach(element => {
            const rents = rentsMap[element.id];
            const hasRents = rents && rents !== 'loading';
            const cell = (value) => (hasRents && value != null) ? applyMaskAmount(value, null, true) : '-';
            const rowData = [
                element.fund_name,
                element.cnpj,
                cell(hasRents ? rents.rentMonth : null),
                cell(hasRents ? rents.rentYear : null),
                cell(hasRents ? rents.rent12m : null),
                cell(hasRents ? rents.rent24m : null),
            ];
            if (SHOW_RENT_INICIO) rowData.push(cell(hasRents ? rents.rentHistoric : null));
            ws_data.push(rowData);
        });

        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        wb.Sheets[sheetName] = ws;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), titleFile + '.xlsx');

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: false,
        }));
    }

    return (
        <div className={classes.root}>

            <div class={'defaultScrollWithHeaderContent'}>
                <div className={classes.tableSideGraph}>
                    <MyTable
                        pagination={isEmpty(search) && funds && funds.length > 0}
                        itemspage={itemsPage}
                        totalitems={funds ? funds.length : 0}
                        handlePage={(value) => setPage(page + value)}
                        stickyHeader
                        size="small"
                        selectable={selectable}>
                        <colgroup>
                            <col width="30%" />
                            <col width="25%" />
                            <col width="45%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left" onClick={() => handleSort("fund_name")}>
                                    <div style={{ display: 'flex', justifyContent: "flex-start", alignItems: 'center', cursor: 'pointer' }}>
                                        Fundo <SortIcon column={"fund_name"} />
                                    </div>
                                </TableCell>
                                <TableCell align="center">CNPJ</TableCell>
                                <TableCell className={classes.sectionTableCell}
                                    align="center">
                                    <div>{'Rentabilidade'}</div>
                                    <div className={classes.multipleHorizontalTableCell}>
                                        <div className={classes.sortableSubHeader} onClick={() => handleSort("rentMonth")}>
                                            {'Mês (%)'} <SortIcon column={"rentMonth"} />
                                        </div>
                                        <div className={classes.sortableSubHeader} onClick={() => handleSort("rentYear")}>
                                            {'Ano (%)'} <SortIcon column={"rentYear"} />
                                        </div>
                                        <div className={classes.sortableSubHeader} onClick={() => handleSort("rent12m")}>
                                            {'12m (%)'} <SortIcon column={"rent12m"} />
                                        </div>
                                        <div className={classes.sortableSubHeader} onClick={() => handleSort("rent24m")}>
                                            {'24m (%)'} <SortIcon column={"rent24m"} />
                                        </div>
                                        {SHOW_RENT_INICIO &&
                                            <div className={classes.sortableSubHeader} onClick={() => handleSort("rentHistoric")}>
                                                {'Início (%)'} <SortIcon column={"rentHistoric"} />
                                            </div>}
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                visibleFunds.map((row) => {

                                    const rents = rentsMap[row.id];
                                    const loading = rents === undefined || rents === 'loading';

                                    return (
                                        <TableRow
                                            key={'all-fund-' + row.id}
                                            onClick={() => currentUser?.user?.isViewer ? undefined : bladeFund(row)}
                                        >
                                            <TableCell align="left">{row.fund_name}</TableCell>
                                            <TableCell align="center">{row.cnpj}</TableCell>
                                            <TableCell align="center"
                                                className={classes.sectionTableCellData}>
                                                <div className={classes.multipleHorizontalTableCell}>
                                                    <div>{
                                                        loading ? '...'
                                                            : (rents.rentMonth != null ? applyMaskAmount(rents.rentMonth, null, true) + "%" : '-')
                                                    }</div>
                                                    <div>{
                                                        loading ? '...'
                                                            : (rents.rentYear != null ? applyMaskAmount(rents.rentYear, null, true) + "%" : '-')
                                                    }</div>
                                                    <div>{
                                                        loading ? '...'
                                                            : (rents.rent12m != null ?
                                                                applyMaskAmount(rents.rent12m, null, true) + "%"
                                                                :
                                                                <LightTooltip title={'O fundo ainda não possui 12 meses de cotas'} placement="right" arrow>
                                                                    <InfoIcon className={classes.infoIcon} />
                                                                </LightTooltip>)
                                                    }</div>
                                                    <div>{
                                                        loading ? '...'
                                                            : (rents.rent24m != null ?
                                                                applyMaskAmount(rents.rent24m, null, true) + "%"
                                                                :
                                                                <LightTooltip title={'O fundo ainda não possui 24 meses de cotas'} placement="right" arrow>
                                                                    <InfoIcon className={classes.infoIcon} />
                                                                </LightTooltip>)
                                                    }</div>
                                                    {SHOW_RENT_INICIO && <div>{
                                                        loading ? '...'
                                                            : (rents.rentHistoric != null ? applyMaskAmount(rents.rentHistoric, null, true) + "%" : '-')
                                                    }</div>}
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </MyTable>
                </div>

            </div>
        </div >
    );
}